import { TYPES } from "./types";

export const addingNewTransactionStart = () => ({
    type: TYPES.ADDING_NEW_TRANSACTION_START,
});

export const addingNewTransactionSuccess = () => ({
    type: TYPES.ADDING_NEW_TRANSACTION_SUCCESS,
});

export const addingNewTransactionError = (error) => ({
    type: TYPES.ADDING_NEW_TRANSACTION_ERROR,
    payload: error,
});

export const fetchingTransactionsStart = () => ({
    type: TYPES.FETCHING_TRANSACTIONS_START,
});

export const fetchingTransactionsSuccess = (transactions) => ({
    type: TYPES.FETCHING_TRANSACTIONS_SUCCESS,
    payload: transactions,
});

export const fetchingTransactionsError = (error) => ({
    type: TYPES.FETCHING_TRANSACTIONS_ERROR,
    payload: error,
});
